var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',_vm._b({attrs:{"active":_vm.active},on:{"click":function($event){return _vm.$emit('click', $event)},"input":function($event){return _vm.$emit('input', $event)}}},'b-tab',_vm.$props,false),[_vm._t("title"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }